import React from 'react'

const MobilityMuse = () => {
  return (
    <div>Mobility Muse Stufffff oh yeah</div>
  )
}

export default MobilityMuse